import { render, staticRenderFns } from "./EmployeePageClockRecord.vue?vue&type=template&id=2316700b&scoped=true&"
import script from "./EmployeePageClockRecord.vue?vue&type=script&lang=js&"
export * from "./EmployeePageClockRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316700b",
  null
  
)

export default component.exports